import React from 'react';
import { ResponsiveContainer } from 'recharts';

/** Titled card wrapping a responsive recharts chart. Pass a chart element as children. */
const ChartCard: React.FC<{ title: string; empty?: boolean; children: React.ReactElement }> = ({ title, empty, children }) => (
  <section className="surface">
    <h2>{title}</h2>
    {empty ? (
      <p className="muted mb-0">No data for this range.</p>
    ) : (
      <div className="chart-box">
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      </div>
    )}
  </section>
);

export default ChartCard;
